import { render } from "./User.vue?vue&type=template&id=21d76aca"
import script from "./User.js?vue&type=script&lang=js"
export * from "./User.js?vue&type=script&lang=js"

import "./User.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__